var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-private-call-income",
      style: `paddingTop:${_vm.barHeight}px`,
    },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow02.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.closeWeb },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "title" }, [
          _vm.$i18n.locale == "ar"
            ? _c("img", {
                staticClass: "title_ar",
                attrs: { src: require("./images/title_ar.png"), alt: "" },
              })
            : _vm.$i18n.locale == "id"
            ? _c("img", {
                staticClass: "title_ar",
                attrs: { src: require("./images/title_id.png"), alt: "" },
              })
            : _c("img", {
                staticClass: "title_en",
                attrs: { src: require("./images/title.png"), alt: "" },
              }),
        ]),
        _c("div", { staticClass: "content" }, [
          _vm.$i18n.locale == "ar"
            ? _c("img", {
                attrs: { src: require("./images/content_bg_ar.png"), alt: "" },
              })
            : _vm.$i18n.locale == "id"
            ? _c("img", {
                attrs: { src: require("./images/content_bg_id.png"), alt: "" },
              })
            : _c("img", {
                attrs: { src: require("./images/content_bg.png"), alt: "" },
              }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }